import { useCallback } from 'react';
import { Button } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { type QuizGenerateItem } from '@/api/ai/type';
import { RefreshIcon } from '@/icons';
import { CheckSmallCircleFillIcon } from '@/icons/components/CheckSmallCircleFill';
import { cn } from '@/utils';
import { BuildAiGeneratedResult, GenerateResultDescription } from '@/views/build/features/ai-quiz-result/components/GeneratedResult';
import { useAiGeneratedQuizItem } from './useAiGeneratedQuizItem';
export const Success = ({
  items,
  onRetry,
  onClose,
  onDelete
}: {
  items: QuizGenerateItem[];
  onRetry: () => void;
  onClose: () => void;
  onDelete: (item: QuizGenerateItem) => void;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  const {
    unSavedItems,
    selectedItems,
    savedItems,
    setSelectedItems,
    handleSelectItem,
    handleSaveItems,
    handleSelectItemsAtOnce
  } = useAiGeneratedQuizItem(items);
  const handleRetry = useCallback(() => {
    logger.track('ai_유사문제_다시생성');
    onRetry();
  }, [onRetry]);
  const isAddButtonDisabled = selectedItems.length === 0;
  const handleDeleteItem = (item: QuizGenerateItem) => {
    setSelectedItems(selectedItems.filter(d => d !== item));
    onDelete(item);
  };
  return <div className="relative flex min-h-0 flex-1 flex-col" data-sentry-component="Success" data-sentry-source-file="Success.tsx">
      {/* body */}
      <div className="relative flex-1 overflow-y-auto overflow-x-hidden bg-gray-50">
        <BuildAiGeneratedResult selectedAchievementStandards={[]} className="relative !max-w-full !overflow-x-hidden px-md pb-sm mobile-lg:p-lg" resultDescription={<GenerateResultDescription generatedItemsCount={items.length} />} selectedItems={selectedItems} savedItems={savedItems} unSavedItems={unSavedItems} onSelect={handleSelectItem} onSelectAll={() => {
        selectedItems.length > 0 ? handleSelectItemsAtOnce([]) : handleSelectItemsAtOnce(items);
      }} onDelete={handleDeleteItem} data-sentry-element="BuildAiGeneratedResult" data-sentry-source-file="Success.tsx" />
        <div className="flex w-full items-center justify-center pb-md mobile-lg:hidden">
          <Button className="flex border-transparent" onClick={handleRetry} variant="contained" intent="neutral" size="md" leftSlot={<RefreshIcon size="sm" />} data-sentry-element="Button" data-sentry-source-file="Success.tsx">
            {t('build:similarQuiz.modal.retry')}
          </Button>
        </div>
      </div>

      {/* footer */}
      <div className="flex w-full flex-shrink-0 items-center justify-between px-lg py-md">
        <Button className="hidden mobile-lg:flex" onClick={handleRetry} variant="contained" intent="neutral" size="md" leftSlot={<RefreshIcon size="sm" />} data-sentry-element="Button" data-sentry-source-file="Success.tsx">
          {t('build:similarQuiz.modal.retry')}
        </Button>
        <div className="flex w-full flex-row gap-xs mobile-lg:w-auto">
          <Button variant={'transparent'} intent="neutral" size="lg" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="Success.tsx">
            {t('common:global.cancel.button')}
          </Button>
          <Button onClick={() => {
          logger.track('ai_유사문제_저장', {
            selectedCount: selectedItems.length,
            totalGenerated: items.length
          });
          handleSaveItems(selectedItems);
        }} className={cn('grow border-none bg-gradient-to-r from-violet-500 to-purple-400 px-2xl', isAddButtonDisabled && 'opacity-[0.54]')} variant={'contained'} intent="strong" size="lg" disabled={isAddButtonDisabled} leftSlot={<CheckSmallCircleFillIcon size="md" />} data-sentry-element="Button" data-sentry-source-file="Success.tsx">
            {t('build:similarQuiz.modal.add')}
          </Button>
        </div>
      </div>
    </div>;
};